export default "__VITE_ASSET__Drqv48GX__"